import React from 'react'
import styled from 'styled-components'
import { LogoIcon } from './logo'
import { Borders, Colors, Fonts, FontWeights, INTEGRAL_APP_SIZE_URL } from '../constants'
import { RightChevron } from './icons'

interface Props {
  className?: string
}

export function MaintenanceBanner({ className }: Props) {
  return (
    <Content className={className}>
      <ColouredLink href={INTEGRAL_APP_SIZE_URL} target="_blank">
        <Text>🛑 FIVE is deprecated and in withdraw only mode. Please use SIZE by clicking here.</Text>
      </ColouredLink>
    </Content>
  )
}

export function LegacyInterfaceBanner({ className }: Props) {
  return (
    <Content className={className}>
      <Link href="https://pre1559.integral.link" target="_blank">
        <Text>
          <Emoji>⚙️</Emoji>
          Having wallet issues after London Hardfork (EIP-1559)?
        </Text>
        <Cta>
          Try our legacy interface
          <RightChevronStyled />
        </Cta>
      </Link>
    </Content>
  )
}

const Content = styled.div`
  display: flex;
  justify-content: center;
`

const Link = styled.a`
  margin: 20px auto 0 auto;
  padding: 15px 20px;
  position: relative;
  display: flex;
  flex-basis: 100%;
  max-width: 980px;
  align-items: center;
  background: #626262;
  background: linear-gradient(217deg, rgba(72, 72, 72, 0.7) 0%, rgba(98, 98, 98, 0.7) 100%);
  color: ${Colors.White};
  text-decoration: none;
  border-radius: ${Borders.Radius};
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);

  @media (max-width: 1000px) {
    border-radius: 0;
    border-left: 0;
    border-right: 0;
  }
`

const ColouredLink = styled(Link)`
  background: rgb(76, 76, 194);
  background: linear-gradient(217deg, rgba(76, 76, 194, 0.9) 0%, rgba(103, 62, 164, 0.9) 100%);
  border: 1px solid rgba(111, 72, 181, 0.9);
`

const Text = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: ${FontWeights.Bold};
`

const Emoji = styled.div`
  margin-right: 10px;
  font-size: 24px;
  white-space: nowrap;
`

const Cta = styled.div`
  margin-left: auto;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  color: ${Colors.White};
  font-size: 14px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  white-space: nowrap;
  border: 1px solid ${Colors.White};
  border-radius: ${Borders.Radius};

  &:hover {
    color: #626262;
    background-color: ${Colors.White};
  }

  @media (max-width: 650px) {
    display: none;
  }
`

const ColouredCta = styled(Cta)`
  &:hover {
    color: rgb(76, 76, 194);
    background-color: ${Colors.White};
  }
`

const RightChevronStyled = styled(RightChevron)`
  margin-left: 5px;
`

const TextContainer = styled.div`
  position: relative;
  top: -5px;
  font-size: 15px;
  line-height: 25px;
`

const IntegralTwap = styled.strong`
  padding-right: 10px;
  position: relative;
  top: 9px;
  display: inline-flex;
  align-items: center;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Semibold};
  text-transform: uppercase;
  white-space: nowrap;

  svg {
    margin-right: 5px;
    height: 28px;
  }
`
